import { Component } from 'react';
import theme from '../theme';
import { MOCK_MORE_DROPDOWN } from '../../lib/constants';

export const createMoreNavSlot = ({ moreText, dropdownEntries }) => ({
  name: 'Mock More Dropdown',
  text: moreText || 'More',
  analyticsSlug: 'more',
  openInNewTab: false,
  showAsDropdown: true,
  boldText: true,
  navSlotPurpose: MOCK_MORE_DROPDOWN,
  rootCategory: null,
  dropdownEntries,
});

class NavigationMediaQueryHelper extends Component {
  constructor(props) {
    super(props);
    this.firstNavWidth = theme.navBreakpoints.defaultWidth;
    this.secondNavWidth = 0;
    this.firstSlotsWidth = [];
    this.secondSlotsWidth = [];
    this.requiredSlotsWidth = 0; // Total width of all slots that cannot be collapsed

    // We display all slots at first so that we can get their width
    this.state = {
      displayedFirstSlots: props.firstNavSlots,
      displayedSecondSlots: props.secondNavSlots,
      hideAnchors: true
    }
  }

  isButton = (slot) => {
    return !!slot.buttonStyle;
  };

  isDropdown = (slot) => {
    return slot.showAsDropdown;
  };

  belongsInNavBar = (slot) => {
    return this.isButton(slot) || this.isDropdown(slot);
  };

  componentDidMount() {
    if (!window) {
      return;
    }

    // Need to calculate width of every slot in the category bar
    this.requiredSlotsWidth = 0;
    this.firstNavWidth = 0;
    const firstNavItems = document.getElementById('firstCategoryBar').children;
    for (let i = 0; i < firstNavItems.length; i++) {
      // * 2 for left + right margin
      const margin = this.isButton(this.props.firstNavSlots[i]) ? theme.navBreakpoints.navButtonMarginOffset : theme.navBreakpoints.navItemMarginOffset;
      const width = firstNavItems[i].getBoundingClientRect().width + margin * 2;
      this.firstSlotsWidth[i] = width;
      this.firstNavWidth += width;
      if (this.belongsInNavBar(this.props.firstNavSlots[i])) {
        this.requiredSlotsWidth += width;
      }
    }

    this.secondNavWidth = 0;
    const secondNavItems = document.getElementById('secondCategoryBar').children;
    for (let i = 0; i < secondNavItems.length; i++) {
      // * 2 for left + right margin
      const margin = this.isButton(this.props.secondNavSlots[i]) ? theme.navBreakpoints.navButtonMarginOffset : theme.navBreakpoints.navItemMarginOffset;
      const width = secondNavItems[i].getBoundingClientRect().width + margin * 2;
      this.secondSlotsWidth[i] = width;
      this.secondNavWidth += width;
      if (this.belongsInNavBar(this.props.secondNavSlots[i])) {
        this.requiredSlotsWidth += width;
      }
    }

    this.onWindowResize();
    this.setState({
      hideAnchors: false
    });

    window.addEventListener('resize', this.onWindowResize);
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.onWindowResize);
    }
  }

  onWindowResize = () => {
    const totalWidth = document.getElementById('navBar').getBoundingClientRect().width;
    if (totalWidth >= this.firstNavWidth + this.secondNavWidth) {
      // Don't need more dropdown
      this.setState({
        displayedFirstSlots: this.props.firstNavSlots,
        displayedSecondSlots: this.props.secondNavSlots
      })
    } else {
      // Move all slots that don't fit and are collapsable into 'more' dropdown
      const moreWidth = theme.navBreakpoints.moreWidth;
      let remainingWidth = totalWidth - moreWidth - this.requiredSlotsWidth;
      let collapseRemainingSlots = false;

      let displayedFirstSlots = [];
      let displayedSecondSlots = [];
      let collapsedSecondItems = [];
      // Add as many second nav slots as possible, then add the rest to 'more'
      for (let i = this.props.secondNavSlots.length - 1; i >= 0; i--) {
        const slot = this.props.secondNavSlots[i];
        if (this.belongsInNavBar(slot)) {
          displayedSecondSlots.unshift(slot);
        } else if (remainingWidth >= this.secondSlotsWidth[i] && !collapseRemainingSlots) {
          remainingWidth -= this.secondSlotsWidth[i];
          displayedSecondSlots.unshift(slot);
        } else {
          collapseRemainingSlots = true;
          collapsedSecondItems.unshift(slot);
        }
      }

      let collapsedFirstItems = [];
      // Add as many first nav slots as possible, then add the rest to 'more'
      for (let i = 0; i < this.props.firstNavSlots.length; i++) {
        const slot = this.props.firstNavSlots[i];
        if (this.belongsInNavBar(slot)) {
          displayedFirstSlots.push(slot);
        } else if (remainingWidth >= this.firstSlotsWidth[i] && !collapseRemainingSlots) {
          remainingWidth -= this.firstSlotsWidth[i];
          displayedFirstSlots.push(slot);
        } else {
          collapseRemainingSlots = true;
          collapsedFirstItems.push(slot);
        }
      }

      const mockNavSlot = createMoreNavSlot({
        moreText: this.props.moreText,
        dropdownEntries: [...collapsedFirstItems, ...collapsedSecondItems],
      });
      displayedFirstSlots.push(mockNavSlot);

      this.setState({
        displayedFirstSlots,
        displayedSecondSlots
      })
    }
  }

  render() {
    const {
      displayedFirstSlots,
      displayedSecondSlots,
      hideAnchors
    } = this.state

    const {renderDesktopBody} = this.props;

    return renderDesktopBody(displayedFirstSlots, displayedSecondSlots, hideAnchors);
  }
}

export default NavigationMediaQueryHelper
